import { PortalService, useToken } from "./portal";
import { WalletService } from "./axios";

export { WalletService, PortalService, useToken };


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/services/index.js